/**
 * One row open at a time for the Fandom accordion style (`.accordion[data-fd-accordion-single]`).
 *
 * `toggle` does not bubble, so one capturing listener on the document covers every accordion on the page,
 * including ones the theme editor adds later. Only the accordion block with the single-open setting is affected.
 */
document.addEventListener(
  'toggle',
  (event) => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.open) return;

    const accordion = details.closest('.accordion[data-fd-accordion-single]');
    if (!accordion) return;

    for (const other of accordion.querySelectorAll('details[open]')) {
      if (other !== details) /** @type {HTMLDetailsElement} */ (other).open = false;
    }
  },
  true
);
